(function () {
  'use strict';

  if (window.__BC_PICKUP_STOCK_SAFE__) return;
  window.__BC_PICKUP_STOCK_SAFE__ = true;

  const STOREFRONT_TOKEN = '6d05bae4dc6253d0bcf381bebac24287';
  const SHOP_DOMAIN =
    (window.Shopify && window.Shopify.shop) ||
    'loja-online-babycool.myshopify.com';
  const API_VERSION = '2026-07';
  const ON_ORDER_FALLBACK = 'Não temos stock: Artigo por Encomenda.';

  const stockCache = new Map();
  const pendingRequests = new Map();

  let productTagsCache = null;
  let activeVariantId = null;
  let activeStockMap = {};

  function normalizeLocationId(value) {
    return String(value || '').split('/').pop();
  }

  function normalizeTag(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(/\s+/g, ' ');
  }

  function getProductTagsText(el) {
    const elementTags = String(el?.dataset?.productTags || '').trim();
    if (elementTags) return elementTags;
    if (productTagsCache !== null) return productTagsCache;

    productTagsCache = '';

    const sectionData = document.querySelector(
      'script[data-section-type="static-product"][data-section-data]'
    );
    if (!sectionData) return productTagsCache;

    try {
      const section = JSON.parse(sectionData.textContent);
      if (Array.isArray(section?.product?.tags)) {
        productTagsCache = section.product.tags.join(',');
      }
    } catch (error) {
      console.error('[BC Pickup] dados do produto inválidos', error);
    }

    return productTagsCache;
  }

  function hasPorEncomendaTag(productTagsText) {
    return productTagsText
      .split(',')
      .map(normalizeTag)
      .some(function (tag) {
        return tag === 'porencomenda' || tag === 'por encomenda';
      });
  }

  function updatePickupVisibility(stockMap) {
    const container = document.querySelector('[data-surface-pick-up]');
    if (!container) return;

    const pickupElements = Array.from(
      document.querySelectorAll('[data-pickup-stock]')
    );
    const hasPickupStock = pickupElements.some(function (el) {
      const locationId = normalizeLocationId(el.dataset.locationId);
      return Number(stockMap[locationId] || 0) > 0;
    });
    const isOnOrder = hasPorEncomendaTag(
      getProductTagsText(pickupElements[0])
    );

      const hasWarehouseStock = Number(stockMap.__warehouseStock || 0) > 0;
        container.hidden = !hasPickupStock && !hasWarehouseStock && !isOnOrder;
  }

  function getVariantId() {
    const selection = document.querySelector('variant-selection');
    if (!selection) return null;

    const value =
      selection.getAttribute('variant') ||
      selection.querySelector('[data-variants]')?.value;

    return value && /^\d+$/.test(String(value)) ? String(value) : null;
  }

  function getQuantityText(el, quantity) {
    if (quantity === 0) return el.dataset.stockOutOfStock || '';
    if (quantity === 1) return el.dataset.stockLastUnit || '';
    if (quantity === 2 || quantity === 3) return el.dataset.stockLastUnits || '';
    return '';
  }

  function getStockTimeMessage(el, stockMap) {
    const locationId = normalizeLocationId(el.dataset.locationId);
    const productTagsText = getProductTagsText(el);
    const isOnOrder = hasPorEncomendaTag(productTagsText);

    const sameLocationText = el.dataset.stockSameLocation || '';
    const otherStoreText = el.dataset.stockOtherStore || '';
    const onOrderText = (el.dataset.stockOnOrder || ON_ORDER_FALLBACK).trim() || ON_ORDER_FALLBACK;

    const stockHere = Number(stockMap[locationId] || 0) > 0;
    if (stockHere) return sameLocationText;

    const hasWarehouseStock = Number(stockMap.__warehouseStock || 0) > 0;
    if (hasWarehouseStock) return otherStoreText;

    const hasStockInAnotherStore = Object.keys(stockMap).some(function (key) {
      return key !== locationId && key !== '__warehouseStock' && Number(stockMap[key] || 0) > 0;
    });

    if (hasStockInAnotherStore) return otherStoreText;

    if (isOnOrder) return onOrderText;

    return '';
  }

  function getFinalMessage(el, stockMap) {
    const locationId = normalizeLocationId(el.dataset.locationId);
    const quantity = Number(stockMap[locationId] || 0);
    const qtyText = getQuantityText(el, quantity);
    const qtyLabel = el.dataset.stockLabel ? (el.dataset.stockLabel + ' ') : '';
    const pickupText = getStockTimeMessage(el, stockMap);

    const parts = [];

    if (qtyText) {
      parts.push((qtyLabel + qtyText).trim());
    }

    if (pickupText) {
      parts.push(pickupText.trim());
    }

    return parts.join(' — ');
  }

  function renderStockMessage(el, message) {
    if (!message) {
      if (el.childNodes.length) el.replaceChildren();
      return;
    }

    const text = message.trim();
    if (el.textContent.trim() === text) return;
    el.replaceChildren(document.createTextNode(text));
  }

  function applyStock(root) {
    root = root || document;
    root.querySelectorAll('[data-pickup-stock]').forEach(function (el) {
      const message = getFinalMessage(el, activeStockMap || {});
      renderStockMessage(el, message);
    });
    updatePickupVisibility(activeStockMap || {});
  }

  async function fetchStock(variantId) {
    if (stockCache.has(variantId)) return stockCache.get(variantId);
    if (pendingRequests.has(variantId)) return pendingRequests.get(variantId);

    const query = `
      query PickupStock($id: ID!) {
        node(id: $id) {
          ... on ProductVariant {
            quantityAvailable
            storeAvailability(first: 50) {
              nodes {
                quantityAvailable
                location {
                  id
                  name
                }
              }
            }
          }
        }
      }
    `;

    const request = fetch(`https://${SHOP_DOMAIN}/api/${API_VERSION}/graphql.json`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN
      },
      body: JSON.stringify({
        query,
        variables: { id: `gid://shopify/ProductVariant/${variantId}` }
      })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Storefront API HTTP ' + response.status);
        return response.json();
      })
      .then(function (json) {
        if (json.errors && json.errors.length) {
          throw new Error(json.errors.map(function (error) {
            return error.message;
          }).join(' | '));
        }

        const nodes = json?.data?.node?.storeAvailability?.nodes || [];
        const result = {};
        let pickupStockTotal = 0;
        nodes.forEach(function (item) {
          if (!item?.location?.id) return;
          const quantity = Number(item.quantityAvailable || 0);
          const locationName = String(item.location.name || '')
            .trim()
            .toLocaleLowerCase('pt-PT');
          result[normalizeLocationId(item.location.id)] = quantity;
          pickupStockTotal += Math.max(0, quantity);
          if (locationName.includes('nosso armaz')) {
            result.__warehouseStock = quantity;
          }
        });

        const totalStock = Number(json?.data?.node?.quantityAvailable || 0);
        result.__totalStock = totalStock;
        result.__warehouseStock = Math.max(
          Number(result.__warehouseStock || 0),
          totalStock - pickupStockTotal
        );

        stockCache.set(variantId, result);
        return result;
      })
      .finally(function () {
        pendingRequests.delete(variantId);
      });

    pendingRequests.set(variantId, request);
    return request;
  }

  async function refresh(forcedVariantId) {
    const variantId = String(forcedVariantId || getVariantId() || '');
    if (!/^\d+$/.test(variantId)) return;

    try {
      const stockMap = await fetchStock(variantId);
      if (getVariantId() !== variantId) return;

      activeVariantId = variantId;
      activeStockMap = stockMap;
      applyStock(document);

      console.log('[BC Pickup] stock aplicado', variantId, stockMap);
    } catch (error) {
      console.error('[BC Pickup]', error);
    }
  }

  function bindVariantSelection() {
    const selection = document.querySelector('variant-selection');
    if (!selection) return;

    selection.addEventListener('variant-change', function (event) {
      const variantId = event?.detail?.variant?.id
        ? String(event.detail.variant.id)
        : selection.getAttribute('variant');
      refresh(variantId);
    });

    new MutationObserver(function (mutations) {
      const changed = mutations.some(function (mutation) {
        return mutation.attributeName === 'variant';
      });
      if (!changed) return;
      refresh(selection.getAttribute('variant'));
    }).observe(selection, {
      attributes: true,
      attributeFilter: ['variant']
    });
  }

  function bindPickupContainer() {
    const container = document.querySelector('[data-surface-pick-up]');
    if (!container) return;

    new MutationObserver(function () {
      const variantId = getVariantId();
      if (
        variantId &&
        variantId === activeVariantId &&
        Object.keys(activeStockMap).length
      ) {
        applyStock(container);
      } else {
        refresh(variantId);
      }
    }).observe(container, { childList: true });
  }

  function bindModal() {
    const modalContent = document.querySelector('[data-modal-container-1] [data-modal-content]');
    if (!modalContent) return;

    new MutationObserver(function () {
      if (!modalContent.querySelector('[data-pickup-stock]')) return;

      const variantId = getVariantId();
      if (
        variantId &&
        variantId === activeVariantId &&
        Object.keys(activeStockMap).length
      ) {
        applyStock(modalContent);
      } else {
        refresh(variantId);
      }
    }).observe(modalContent, { childList: true, subtree: true });
  }

  function init() {
    bindVariantSelection();
    bindPickupContainer();
    bindModal();
    refresh();
    console.log('[BC Pickup] iniciado');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
